import styled from 'styled-components';
import SupportHeaderSVG from '../../assets/header/ic-support.svg';

const SupportHeaderIcon = styled(SupportHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.9rem'};
  height: ${props => props.height || '2.7rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default SupportHeaderIcon;
